import React from 'react';
import { string } from 'prop-types';
import { TextStyled } from '@nike/nike-design-system-components';
import { escapeRegExp } from 'nav-utilities';

const HighlightMatch = ({ match }) => (
  <TextStyled Component="span" appearance="title4" color="primary">
    {match}
  </TextStyled>
);

const Highlight = ({ textToHighlight, searchTerm }) => {
  if (!textToHighlight || !searchTerm) {
    return textToHighlight;
  }

  // list of elements to return
  const result = [];

  const regex = new RegExp(escapeRegExp(searchTerm), 'ig');

  // keep track of the last matched offset
  let lastOffset = 0;

  textToHighlight.replace(regex, (match, offset) => {
    result.push(
      // add unmatched portion of string (everything between the previous offset and current offset)
      textToHighlight.slice(lastOffset, offset),
      // add matched portion via HighlightMatch component
      <HighlightMatch key={offset} match={match} />,
    );

    // set lastOffset to end of the match
    lastOffset = offset + match.length;
  });

  // Add the remaining part of the unmatched string to the results list
  result.push(textToHighlight.slice(lastOffset));

  return result;
};

export default Highlight;

Highlight.propTypes = {
  textToHighlight: string,
  searchTerm: string,
};

HighlightMatch.propTypes = {
  match: string,
};
